import { API_DELIMITER } from 'utils/filterUtils'

// Converts legacy filter pipe-delimited values to array
const delimitedStringToArray = (pipedString: string) => pipedString.split(API_DELIMITER)

export default delimitedStringToArray
